import * as Sentry from '@sentry/react'
import React from 'react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'

const dsn = import.meta.env.VITE_SENTRY_DSN?.trim()

Sentry.init({
  dsn: dsn || undefined,
  environment: import.meta.env.MODE,
  release: typeof __APP_VERSION__ !== 'undefined' ? `edictlabs@${__APP_VERSION__}` : undefined,

  debug: import.meta.env.VITE_SENTRY_DEBUG === 'true',

  sendDefaultPii: true,

  integrations: [
    Sentry.reactRouterV7BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      matchRoutes,
      createRoutesFromChildren,
    }),
  ],

  tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/.+\.supabase\.co/],

  // Session Replay removed (Sept 2026): nobody watched replays, and it
  // recorded the page in the background on staff tablets/phones and added
  // ~300 KB to the bundle. Error reports are unaffected.

  enableLogs: true,
})
